<template>
  <td>
    <span :class="relativeQuantityClass(stockChange)">
      <font-awesome-icon v-if="stockChange.realativeQuantity >= 0" :icon="['fas', 'plus-large']" class="text-success" />
      <font-awesome-icon v-if="stockChange.realativeQuantity < 0" :icon="['fas', 'minus']" class="text-danger" />
    </span>
  </td>
  <td class="text-end px-0">
    <div class="d-inline-flex align-items-center">
      <UnitQuantity :quantity="Math.abs(stockChange.realativeQuantity)" :unit-name="stockChange.item.baseUnitCode" :show-unit="false" :pad-length="props.padLength" :show-diff-anim="showDiffAnim" />
      <span class="fs-4 px-1 text-secondary">&equals;</span>
    </div>
  </td>
  <td class="text-end px-0">
    <UnitQuantity :quantity="stockChange.quantity" :unit-name="stockChange.item.baseUnitCode" :show-unit="false" :pad-length="props.padLength" :show-diff-anim="showDiffAnim" />
  </td>
  <td>
    <sup>{{ stockChange.item.baseUnitCode }}</sup>
  </td>
</template>

<script setup lang="ts">
import FrontendStockChange from "@/models/frontend/StockChange";
import UnitQuantity from "../UnitQuantity.vue";

const props = defineProps({
  stockChange: { type: Object as () => FrontendStockChange, required: true },
  padLength: { type: Number, required: false, default: 5, min: 0, max: 5 },
  showDiffAnim: { type: Boolean, required: false, default: false }
});

function relativeQuantityClass(stockChange: FrontendStockChange) {
  return {
    'text-danger': stockChange.realativeQuantity < 0,
    'text-success': stockChange.realativeQuantity >= 0
  };
}
</script>
